import { GridViews } from '../../responseGrid/types';

export interface ResponsePanelItemWebComponentSchema {
  // all the data needed for rendering
  actionCategoryName: string;
  actions: Array<Action>;
  view: GridViews;
  category: number;
}

export interface Action {
  actionName: string;
  numberOfActions: number;
  actionType: number;
}

export const LINK_CLICKED = 'responsePanelLinkClicked';
